import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Select, MenuItem } from 'seagull';
import styles from '../GlobalBillingHub.module.scss';
import { getAgreementOptions, getDefaultRelationshipId } from '../GlobalBillingHub.utils';
export const GlobalBillingHubHeader = (param)=>{
    let { agreements, clientOptions, selectedClient, changeUrlState, setAgreementOptions, agreementOptions, relationshipId } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.filters,
        children: [
            /*#__PURE__*/ _jsx(Autocomplete, {
                freeSolo: true,
                forcePopupIcon: true,
                className: styles.autocomplete,
                testId: "gbh-client",
                options: clientOptions,
                value: selectedClient,
                getOptionLabel: (option)=>option.text,
                textFieldProps: {
                    label: 'Client',
                    placeholder: 'Choose a client to bill'
                },
                onChange: (_, newOption)=>{
                    if (!newOption) {
                        changeUrlState({
                            clientId: '',
                            relationshipId: '',
                            selectedDate: ''
                        });
                        setAgreementOptions([]);
                    } else if (typeof newOption !== 'string' && !Array.isArray(newOption)) {
                        const newClientId = newOption.id;
                        const newAgreementOptions = getAgreementOptions(agreements, newClientId);
                        setAgreementOptions(newAgreementOptions);
                        changeUrlState({
                            clientId: newClientId,
                            relationshipId: getDefaultRelationshipId(newAgreementOptions),
                            selectedDate: ''
                        });
                    }
                }
            }),
            relationshipId && /*#__PURE__*/ _jsx(Select, {
                collapseHelperText: false,
                width: 400,
                label: "Agreement",
                testId: "gbh-relationship",
                value: relationshipId,
                menuMaxHeight: 400,
                placeholder: "No Agreements to show",
                onChange: (e)=>changeUrlState({
                        relationshipId: e.target.value,
                        selectedDate: ''
                    }),
                children: agreementOptions.map((param, idx)=>{
                    let { id, text } = param;
                    return /*#__PURE__*/ _jsx(MenuItem, {
                        value: id,
                        testId: "gbh-relationship-opt-".concat(idx),
                        children: text
                    }, id);
                })
            })
        ]
    });
};
